import { Project } from "../../database/db"

type ProjectToExport = Omit<Project, "id">

const replacer = (key: string, value: unknown) => {
    if (value instanceof Date) {
        return value.getDate()
    }
    return value
}

// file containing the project.
export const exportProject = (project: Partial<ProjectToExport>) => {
    const deepCopy = JSON.parse(JSON.stringify(project)) as Partial<Project>
    delete deepCopy.id
    const blob = new Blob([JSON.stringify(deepCopy, replacer)], {
        type: "application/json",
    })
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.setAttribute("href", url)
    link.setAttribute("download", `${project.name}.json`)
    link.click()
}
